export const ORACLE_PROFILE_FORM_TYPES = {
  ADD: "ADD",
  EDIT: "EDIT",
  DUPLICATE: "DUPLICATE",
};
